import { useState } from 'react'
import AdminPanelCN from 'components/AdminPanelCN/AdminPanelCN'
import HeaderCN from 'components/HeaderCN/HeaderCN'
import UserProfileForm from 'components/UserProfileForm/UserProfileForm'
import { EmailPreferencesSection } from 'features/Notifications/components/EmailPreferencesSection'

/**
 * The user's profile as a full screen.
 *
 * The form itself now lives in `components/UserProfileForm`, because the same
 * thing has to be a popup as well: reaching this route from the field app would
 * eject the user into desktop chrome they had deliberately left.
 *
 * The route is kept rather than replaced. It is the destination of existing
 * bookmarks, and `/admin/userprofile` is on the mobile-allowed list precisely
 * because it is the only path to Logout once the sidebar's User section is
 * hidden.
 */
const UserProfileCN = () => {
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

	return (
		<div className="flex h-screen overflow-hidden bg-gray-50">
			<AdminPanelCN mobileOpen={mobileMenuOpen} onMobileClose={() => setMobileMenuOpen(false)} />

			<div className="flex flex-1 flex-col overflow-hidden">
				<HeaderCN onMobileMenuToggle={() => setMobileMenuOpen(!mobileMenuOpen)} />

				<div className="flex flex-1 overflow-hidden">
					<main className="flex-1 overflow-y-auto p-6">
						<h2 className="mb-4 text-2xl font-semibold text-gray-800">User Profile</h2>

						<UserProfileForm className="mx-auto mt-4 w-full max-w-[1080px] rounded-lg border border-gray-200 bg-white p-5" />

						{/* Saves on its own; the form's Update button never touches it (MYD-543). */}
						<EmailPreferencesSection className="mx-auto mt-6 w-full max-w-[1080px]" />
					</main>
				</div>
			</div>
		</div>
	)
}

export default UserProfileCN
